<template>
  <figure>
    <img
      :src="logo"
      :alt="businessName"
    >
  </figure>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'TheLogo',
  props: {
    wide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      theme: (state) => state.theme.theme,
      pinned: (state) => state.retract.pinned,
    }),
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    businessName() {
      return this.theme?.name ?? '';
    },
    logo() {
      const {
        desktop,
        desktop_white: desktopWhite,
        mobile,
        mobile_white: mobileWhite,
      } = this.theme?.styles?.logo ?? {};

      if (this.wide) return desktopWhite ?? desktop ?? '';

      return this.isMobile || (this.pinned && !this.isMobile)
        ? mobileWhite ?? mobile ?? ''
        : desktopWhite ?? desktop ?? '';
    },
  },
};
</script>

<style lang="scss" scoped>
figure {
  display: flex;
  background-color: $color-primary;

  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 100%;
    height: 100%;
    padding: 10px;
    object-fit: contain;

    @media(max-width: $breakpoint-mobile){
      width: 55px;
      max-width: 80%;
    }
  }
}
</style>
